export default "__VITE_ASSET__KxBMhq2L__"